import { Message } from "../../../domain/model/Auth";
import { Customer } from "../../../domain/model/Customer";
import { Order, UpdateOrderModel } from "../../../domain/model/Order";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { OrderRepository } from "./OrderRepository";

export class OrderRepositoryImpl implements OrderRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getAll(skip?: number, limit?: number): Promise<Response<Array<Order>>> {
    return this.apiService.getOrders(skip, limit);
  }
  getById(id: string): Promise<Response<Order>> {
    return this.apiService.getOrderById(id);
  }
  update(id: string, model: UpdateOrderModel): Promise<Response<Message>> {
    return this.apiService.updateOrder(id, model);
  }
  deliver(
    id: string
  ): Promise<Response<{ message: string; deliveryInfo: any }>> {
    return this.apiService.deliverOrder(id);
  }
  downloadReceipt(id: string): Promise<Response<Blob>> {
    return this.apiService.downloadOrderReceipt(id);
  }
  downloadMultipleOrderReceipts(ids: Array<string>): Promise<Response<Blob>> {
    return this.apiService.downloadMultipleOrderReceipts(ids);
  }
}
